import { IOS_BUILD_VERSION, IS_DEV_BUILD, IS_IOS_MOBILE, IS_MAIL_APP_IOS, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { getFeatureQuotaBuyIOSConfig, quotaBuyWebviewIOSConfig } from 'reactApp/appHelpers/featuresHelpers';
import { dmrMidasBuyEnabled } from 'reactApp/appHelpers/featuresHelpers/features/dmrMidas';
import { REFERRAL_BUY_CODE } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { getSourceString } from 'reactApp/appHelpers/settingsHelpers';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';

import { type BuyAction, type CommonBuyApiParams, BillingBuyTemplates, MidasPlatform } from './billing.types';

export const getRequestId = (): string => Date.now().toString();

export const getMidasPaymentLink = (url: string) => {
    if (!dmrMidasBuyEnabled) {
        return url;
    }

    return url?.replace(/\/\/pw\.money\.mail\.ru\/pw\/[\d-]+\//, '//co.vkpay.io/');
};

export const getBuyApiParams = ({ isMobile, source, paySource, description, isMidas, hidePayMethods }: BuyAction): CommonBuyApiParams => {
    const defaultSkin = isMobile ? BillingBuyTemplates.CHECKOUT_VKPAY_NOOFFER : BillingBuyTemplates.CHECKOUT_VKPAY;

    const result: CommonBuyApiParams = {
        view: 'checkout',
        skin: isMidas ? BillingBuyTemplates.VK_WALLET_V2 : defaultSkin,
        source: getSourceString(source, isMobile, paySource),
        hide_header: hidePayMethods,
        hide_pay_methods_menu: hidePayMethods,
        hide_login_button: isMidas && isMobile && IS_WEBVIEW,
        hide_close_button: true,
        description,
        fullscreen: isMobile && isMidas,
        view_platform: isMobile && isMidas ? MidasPlatform.mobile : undefined,
    };
    // tempexp_18086-start
    const refCode = storeHelper.getValue(REFERRAL_BUY_CODE);
    if (refCode) {
        result.ref_code = refCode;
    }
    // tempexp_18086-end
    return result;
};

export const checkMobileWebviewPayAvailable = (): boolean => {
    // Открыто в приложении почты без build-версии
    if (!IOS_BUILD_VERSION && IS_MAIL_APP_IOS && IS_IOS_MOBILE) {
        return true;
    }

    if ((!IS_WEBVIEW && !IS_MAIL_APP_IOS) || !IS_IOS_MOBILE) {
        return true;
    }

    // для дев сборок всегда включаем оплаты
    if (IS_DEV_BUILD) {
        return true;
    }

    const config = IS_MAIL_APP_IOS ? getFeatureQuotaBuyIOSConfig : quotaBuyWebviewIOSConfig;

    if (!IOS_BUILD_VERSION || !config) {
        return false;
    }

    const { start, end } = config || {};

    // если нет стартовой версии, то не валидно
    if (!start) {
        return false;
    }

    const buildNum = +IOS_BUILD_VERSION;

    if (buildNum < start) {
        return false;
    }

    // если нет конечной версии, то оплата включена, иначе проверяем < конечной
    return end ? buildNum < end : true;
};
